
import applicationModuleLoader from '../utils/applicationModuleLoader/index'

import slotTrakUtils from '../utils/index'
import slotTrakUi from '../ui/index'

const {
  vsServiceName: SelectPartQuantityModalServiceName,
  SelectPartQuantityModalService,
} = require('./controls/selectPartQuantityModal')

var deps = [
  'ui.router',
  'angularGrid',
  slotTrakUtils,
  'ngSanitize',
  'SlotTrak.Machines',
  slotTrakUi,
  'ui.bootstrap'
]

var mod = angular.module('SlotTrak.Parts', deps)

applicationModuleLoader(mod, [
  require('./routes'),
  require('./server'),
  require('./Pages/applyToMachine/index'),  
  require('./Pages/recoverFromMachine/index'),
  require('./Pages/checkedOut'),
  require('./Pages/checkedOut/grid'),
  require('./Pages/checkout/index'),
  require('./Pages/edit/index'),
  require('./Pages/main/index'),
  require('./Pages/orders'),
  require('./Pages/orders/grid'),
  require('./Pages/orders/edit'),
  require('./Pages/orders/detail'),
  require('./Pages/orders/detail/items'),
  require('./Pages/orders/detail/items/edit'),
  require('./Pages/orders/detail/distribute'),
  require('./Pages/main/grid/datasource'),
  require('./Pages/main/grid/index'),
  require('./Pages/detail/index'),
  require('./Pages/detail/locations/index'),
  require('./Pages/detail/locations/edit/index'),
  require('./Pages/detail/partGroup/index'),
  require('./Pages/detail/partGroup/edit/index'),
  require('./Pages/detail/orders'),
  require('./Pages/detail/orders/grid'),
  require('./Pages/repair/index'),
  require('./Pages/returnToInventory/index'),
  require('./Pages/partProperties/grid/index'),
  require('./Pages/partProperties/edit/index'),
  require('./controls/selectPartGrid/index'),
  require('./controls/selectPartModal/index'),
  require('./ui-formly/types/partDropDown/index'),
  require('./ui-formly/types/selectPart/index'),
  require('./ui-formly/types/selectParts/index'),
  require('./controls/selectMachinePartModal')
])

mod
  .service(SelectPartQuantityModalServiceName, SelectPartQuantityModalService)

export default mod.name


